import { render, staticRenderFns } from "./EmployerGroupAddressContent.vue?vue&type=template&id=2fdbaa68&"
import script from "./EmployerGroupAddressContent.vue?vue&type=script&lang=js&"
export * from "./EmployerGroupAddressContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports